import type { ReactNode } from 'react';

export const symbol_align_vertical_bottom: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M110-80q-12.75 0-21.37-8.68Q80-97.35 80-110.18q0-12.82 8.63-21.32Q97.25-140 110-140h740q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q862.75-80 850-80H110Zm194.5-174.58Q290-269.17 290-290v-540q0-20.83 14.62-35.42Q319.24-880 340.12-880q20.88 0 35.38 14.58Q390-850.83 390-830v540q0 20.83-14.62 35.42Q360.76-240 339.88-240q-20.88 0-35.38-14.58Zm280 0Q570-269.17 570-290v-300q0-20.83 14.62-35.42Q599.24-640 620.12-640q20.88 0 35.38 14.58Q670-610.83 670-590v300q0 20.83-14.62 35.42Q640.76-240 619.88-240q-20.88 0-35.38-14.58Z"
		/>
	</svg>
);
